/**
 * This file contains logic related to the Language filter.
 */

/**
 * Return the languages available through currently-visible projects.
 * @return Set<string>
 */
export function getLanguages() {
  const languages = new Set();
  // Count up the bible types for all the visible projects.
  $('.products-list>li:visible').each(function () {
    languages.add($(this).attr('data-language-name'))
  })
  return languages;
}

/**
 * Determine which languages are currently selected.
 */
export function getSelectedLanguages() {
  const selectedLanguages = new Set<string>();
  $('#language-filter .selected-holder .selected-lang').each(function () {
    selectedLanguages.add($(this).attr('data-value'));
  })
  return selectedLanguages;
}

/**
 * Determine whether a project should be shown based on language.
 * @param project The top level project element. (i.e. '.products-list>li')
 * @param selectedLanguages The selected languages.
 */
export function showProjectBasedOnLanguage(project: HTMLElement, selectedLanguages: Set<string>) {
  let show = true;
  const language = $(project).attr('data-language-name');

  if (selectedLanguages.size && !selectedLanguages.has(language)) {
    show = false;
  }
  return show;
}

/**
 * Hide any project that doesn't match at least one selected language.
 * Show all projects if no languages are selected.
 */
export function showHideProjectsByLanguage() {
  const selectedLanguages = getSelectedLanguages();
  $('.products-list>li').each(function () {
    if (showProjectBasedOnLanguage(this, selectedLanguages)) {
      $(this).show();
    } else {
      $(this).hide();
    }
  })
}
